export default function searchBarFactory(
    siteService,
    houseService,
    moment,
    $rootScope,
    UrlFactory,
    timeFactory,
    $timeout,
    Scroll
) {
    var factory = {
        oSearchActive: null, //used by Keyboard Nav Factory

        searchbarImageMode: "",

        searchBarFields: { hasValue: false },

        //Main Objects for inputs
        oSearchCategory: {},
        oSearchType: {},
        oSearchCalender: {},
        oSearchTime: {},

        /**********************************
         * Array To hold all Input objects
         **********************************/
        aSearchInputs: [],

        createSearchObjects: function () {
            /**********************************
             * Search input objects - Category/Type
             **********************************/
            var typeDropdown = {
                type: "input",
                dirty: false,
                suggested: false,
                placeholder: "",
                placeholderDisplay: "",
                input: "",
                filter: "",
                items: [],
                filteredItems: {}, //container filterInUse
                buffer: false,
                display: false,
                noResults: false,
                activeDropdown: false,
                defaultItem: false,
                keyboardNav: false,
                keyboardActive: false,
                hightligtedItem: null,
                animateMenu: false,
                dropDownState: {
                    activeMenuParentId: 0,
                    children: {},
                },
                hideIcons: false,
            };

            var oSearchCategory = angular.copy(typeDropdown);
            var oSearchType = angular.copy(typeDropdown);

            oSearchCategory["name"] = "search-activity";
            oSearchCategory["placeholder"] = "Vælg aktivitet";

            oSearchType["name"] = "search-location";
            oSearchType["placeholder"] = "Vælg sted";

            /**********************************
             * Search input objects -cCalender/Time
             **********************************/

            var typeDropdownNoInput = {
                type: "selection",
                arrPos: null,
                placeholder: "",
                dirty: false,
                display: false,
                activeDropdown: false,
                keyboardNav: false,
                animateMenu: false,
                hideIcons: false,
            };

            var oSearchCalender = angular.copy(typeDropdownNoInput);
            var oSearchTime = angular.copy(typeDropdownNoInput);

            /*cCALENDER */
            oSearchCalender["name"] = "search-calender";

            oSearchCalender["placeholder"] = "Dato";
            oSearchCalender["userSelected"] = {
                date: houseService.calenderFilter.startDate(),
                display: "",
            };

            /* TIME (Mobiscroll) */

            oSearchTime["name"] = "search-time";

            oSearchTime["placeholder"] = "Tid";
            oSearchTime["default"] = {
                from: houseService.calenderFilter.startTime(), // houseService.searchFilter.startTime,
                to: houseService.searchFilter.endTime,
                duration: houseService.searchFilter.hours,
                display: "",
            };

            oSearchTime["userSelected"] = angular.copy(oSearchTime["default"]);

            // oSearchTime["mobiscroll"] = {
            //     init: false,
            //     update: 1,
            // };

            timeFactory.init(oSearchTime);

            // Hardcoded array position - easy way to find the next dropdown without array lookup
            oSearchCategory["arrPos"] = 0;
            oSearchType["arrPos"] = 1;
            oSearchCalender["arrPos"] = 2;
            oSearchTime["arrPos"] = 3;

            // push to array
            this.aSearchInputs.push(oSearchCategory);
            this.aSearchInputs.push(oSearchType);
            this.aSearchInputs.push(oSearchCalender);
            this.aSearchInputs.push(oSearchTime);
        },
        get_oSearchCategory: function () {
            return this.aSearchInputs[0];
        },
        get_oSearchType: function () {
            return this.aSearchInputs[1];
        },
        get_oSearchCalender: function () {
            return this.aSearchInputs[2];
        },
        get_oSearchTime: function () {
            return this.aSearchInputs[3];
        },
    };

    factory.updateSearchBar = function (activity, location, date) {
        activity
            ? factory.selectItem(activity, factory.oSearchCategory, false)
            : null;
        location
            ? factory.selectItem(location, factory.oSearchType, false)
            : null;

        date ? factory.updateCalender(date) : null;

        // if (!!start && !!end) {
        //     // double bangs
        //     // just make sure "start" and "end" is not null
        //     factory.updateTime(start, end);
        // } else {
        //     console.error("Missing time var");
        // }

        // hours ? factory.updateHours(hours) : null;
    };

    factory.selectItem = function (
        selectedItem,
        oSearchInput,
        handleUI = true
    ) {
        if (selectedItem.isBackToRootMenuItem) {
            return factory.backToRootMenu(oSearchInput);
        }
        // UrlFactory.swapPathFragment(selectedItem.Name, oSearchInput.name);
        factory.activatePossibleItems(selectedItem, oSearchInput.name);

        // set the input filter
        oSearchInput.input = angular.copy(selectedItem.Name);

        // Set the search buffer
        oSearchInput.suggested = angular.copy(selectedItem);
        oSearchInput.buffer = angular.copy(selectedItem);

        oSearchInput.placeholderDisplay = "";

        //console.log(oSearchInput);
        factory.setInputDirtyness(selectedItem, oSearchInput);

        if (handleUI) {
            factory.deactivateDropdown(oSearchInput);
            factory.focusOpenBtn(oSearchInput);
            //factory.openNextDropdown(oSearchInput);
        }
    };

    factory.setSuggestedItem = function (oSearchInput, suggestedItem) {
        oSearchInput.suggested = suggestedItem;

        return oSearchInput;
    };

    factory.useSuggestedItem = function (oSearchInput) {
        // display to user
        if (oSearchInput.input || oSearchInput.hightligtedItem) {
            oSearchInput.input = angular.copy(oSearchInput.suggested.Name);
        }

        // copy to buffer
        oSearchInput.buffer = angular.copy(oSearchInput.suggested);

        return oSearchInput;
    };

    factory.addBackButtonToArrayOfItems = (arrayOfItems, ParentCategoryID) => {
        // Add new array object to the beginning of the array

        const items = angular.copy(arrayOfItems);

        if (!items) return [];

        items.unshift({
            CategoryID: -99,
            Name: "Tilbage",
            ChildCategories: null,
            ItemName: null,
            Level: 1,
            ParentID: ParentCategoryID,
            Searchable: false,
            active: true,
            tabindex: -1,
            isBackToRootMenuItem: true,
        });

        return items;
    };

    factory.showSubMenu = function (array, CategoryID, oSearchInput) {
        oSearchInput.animateMenu = true;
        oSearchInput.dropDownState.activeMenuParentId = CategoryID;

        var i = 0;
        var len = array.length;

        for (; i < len; i++) {
            if (array[i].CategoryID == CategoryID) {
                // only works for activity

                // console.log(array[i].ChildCategories);

                const childItems = angular.copy(
                    factory.addBackButtonToArrayOfItems(
                        array[i].ChildCategories,
                        CategoryID
                    )
                );

                oSearchInput.dropDownState.children = childItems;

                // console.log("SHOW SUB MENU", childItems);
                // Select and set focus on first element in sub menu
                if (childItems.length > 0) {
                    // oSearchInput.dropDownState.children[0].tabindex = 0;

                    oSearchInput.hightligtedItem = childItems[0];

                    // console.log(
                    //     "set Focus to : ",
                    //     ".aBook-submenu #item-" + childItems[0].CategoryID
                    // );

                    setTimeout(function () {
                        factory.setFocusItem(
                            childItems[0].CategoryID,
                            ".aBook-submenu"
                        );
                    }, 10);
                }
            }
        }
    };

    factory.backToRootMenu = function (oSearchInput) {
        const parentItem = oSearchInput.items.find((item) => {
            return (
                item.CategoryID == oSearchInput.dropDownState.activeMenuParentId
            );
        });

        factory.setSuggestedItem(oSearchInput, parentItem);

        // reset
        oSearchInput.dropDownState.activeMenuParentId = 0;
        oSearchInput.dropDownState.children.length = 0;

        // factory.useSuggestedItem(oSearchInput);

        setTimeout(function () {
            oSearchInput.animateMenu = false;

            oSearchInput.hightligtedItem = parentItem;
            factory.setFocusItem(parentItem.CategoryID, ".aBook-menu");
        }, 400);
    };

    factory.focusCloseBtn = function (oSearchActive) {
        console.log("focusCloseBtn");
        $timeout(function () {
            $("#" + oSearchActive.name + " .close-focus-selector")
                .attr("tabindex", 0)
                .focus();
        });
    };

    factory.focusOpenBtn = function (oSearchActive) {
        console.log("focusCloseBtn");
        $timeout(function () {
            $("#" + oSearchActive.name + " .open-focus-selector")
                // .attr("tabindex", 0)
                .focus();
        });
    };

    factory.removeTabindexOnCloseBtn = function (oSearchActive) {
        $("#" + oSearchActive.name + " .close-focus-selector").attr(
            "tabindex",
            -1
        );
    };

    factory.itsTheDefaultItem = function (selectedItem) {
        if (
            selectedItem == false ||
            selectedItem.CategoryID == 0 ||
            selectedItem.ID == -1
        ) {
            return true;
        }

        return false;
    };

    factory.setInputDirtyness = function (selectedItem, oSearchInput) {
        // if (!factory.itsTheDefaultItem(selectedItem)) {
        //     console.log("are you kidding");
        // }

        if (selectedItem == false) {
            oSearchInput.dirty = true;
        }
    };

    factory.deactivateDropdown = function (oSearchInput) {
        oSearchInput.activeDropdown = false;

        factory.resetAllTabindexOnItems(oSearchInput);

        factory.checkIfAnySearchBarInputHasValue();
    };

    factory.resetAllTabindexOnItems = function (oSearchInput) {
        if (oSearchInput.type != "input" || oSearchInput.items.length < 0)
            return false;

        factory.removeTabindexOnCloseBtn(oSearchInput);

        oSearchInput.items.map((item) => {
            item.tabindex = -1;

            if (item.ChildCategories) {
                item.ChildCategories.map((childItem) => {
                    childItem.tabindex = -1;
                });
            }
        });
    };

    /*********************************************
     * USER -> INPUT BLUR - ( leaves input field )
     *********************************************/

    factory.userLeavingInput = function (oSearchInput) {
        // chains to deactivateDropdown
        // note: which is also called when new page is loaded
        if (oSearchInput.type == "input") {
            if (oSearchInput.filter) {
                // set selected item (buffer) to best match if user did not complete the typed search
                factory.useSuggestedItem(oSearchInput);
            }

            oSearchInput.noResults = false;
            oSearchInput.filter = false;

            factory.setInputDirtyness(oSearchInput.buffer, oSearchInput);
        }

        factory.deactivateDropdown(oSearchInput);
    };

    factory.looseFocusInput = function (oSearchInput) {
        $("#" + oSearchInput.name + " input").blur();
    };

    // factory.gainFocusInput = function (oSearchInput) {
    //     $("#" + oSearchInput.name + " input").focus();
    // };
    factory.setFocusOnSubmitButton = function () {
        $("#search-btn-main a").focus();
    };

    factory.setFocusItem = function (id, prefixClass = undefined) {
        const prefix = prefixClass ? prefixClass + " " : "";
        // console.log(prefix + "#item-" + id);

        $timeout(function () {
            $(prefix + "#item-" + id).focus();
        });
    };

    factory.setFocusField = function (identifier) {
        $("#" + identifier + " input").focus();
    };

    factory.openNextDropdown = function (oSearchInput) {
        //console.log(oSearchInput.arrPos +' vs ' + (factory.aSearchInputs.length - 1) );

        if (oSearchInput.arrPos !== factory.aSearchInputs.length - 1) {
            var nextDropdown = factory.aSearchInputs[oSearchInput.arrPos + 1];

            console.log(nextDropdown);
            factory.activateDropdown(nextDropdown);
            factory.setFocusField(nextDropdown.name);
        } else {
            // DO SEARCH
        }
    };

    factory.resetAndCloseDropdown = (oSearchInput) => {
        factory.resetsearchInput(oSearchInput);
        factory.deactivateDropdown(oSearchInput);
    };
    factory.checkIfAnySearchBarInputHasValue = function () {
        // OBS bliver kaldt unødvendig mange gange ved klik på søg! (trace: search :: deactivateAllDropdowns :: deactivateDropdown );

        var foundValue = false;
        angular.forEach(factory.aSearchInputs, function (oSearchInput) {
            if (oSearchInput.type == "input") {
                if (oSearchInput.input && oSearchInput.input.length > 0) {
                    foundValue = true;
                }
            }

            if (oSearchInput.type == "selection") {
                // console.log(oSearchInput.userSelected.display);
                if (oSearchInput.userSelected.display.length > 0) {
                    foundValue = true;
                }
            }
        });

        factory.searchBarFields.hasValue = foundValue;
    };

    /*******************************
     * USER -> Activate Dropdown
     *******************************/

    factory.activateDropdown = function (oSearchInput) {
        console.log(oSearchInput);
        if (!oSearchInput.activeDropdown) {
            // just to be sure

            factory.deactivateAllDropdowns(); // Close all dropdowns

            factory.scrollToElem(
                oSearchInput.name,
                siteService.headerHeight + 15
            );

            // factory.resetsearchInput(oSearchInput, false);

            // if (oSearchInput.name == "searchcalender") {
            //     //angular.element('datepicker').focus();
            // }

            // if (oSearchInput.name == "search-time") {
            //     $rootScope.$broadcast("checkMobiscrollBroadcast");
            // }

            oSearchInput.activeDropdown = true; // open this dropdown
            oSearchInput.keyboardActive = true; // used to determine keyboard icon (not keyboard Navigation)

            // Set current Active Dropdown in factory
            factory.oSearchActive = oSearchInput;
        }
    };

    factory.deactivateAllDropdowns = function () {
        var activeInputField = 0;

        factory.oSearchActive = null;

        angular.forEach(factory.aSearchInputs, function (oSearchInput, key) {
            if (oSearchInput.activeDropdown) {
                activeInputField = key;
            }

            // reset
            oSearchInput.hightligtedItem = null;

            // deactivate it
            oSearchInput.activeDropdown = false;
        });

        factory.userLeavingInput(factory.aSearchInputs[activeInputField]);
    };

    /**********************************
     * AUTO SCROLL HANDLER
     *********************************/

    factory.scrollToElem = function (elemID, offset) {
        Scroll.to(elemID, offset);
    };

    /*******************************
     * RESET - search house object
     *******************************/

    /************* reset all ***********************/
    factory.resetSearch = function () {
        angular.forEach(factory.aSearchInputs, function (oHouseInput) {
            factory.resetsearchInput(oHouseInput, true);
        });

        factory.checkIfAnySearchBarInputHasValue();

        // factory.searchBarFields.hasValue = false;
    };

    /************* reset single input ***********************/
    factory.resetsearchInput = function (searchInput, resetAll) {
        if (searchInput.type == "input") {
            // Filter
            searchInput.input = "";
            searchInput.filter = "";
            searchInput.dirty = false;
            searchInput.noResults = false;
            searchInput.suggested = angular.copy(searchInput.defaultItem);
            searchInput.buffer = angular.copy(searchInput.defaultItem);
            searchInput.dropDownState.activeMenuParentId = 0;
        }

        if (resetAll == true && searchInput.type == "selection") {
            console.log(searchInput.type);
            if (searchInput.name == "search-calender") {
                // get default from service
                searchInput.userSelected.date =
                    houseService.calenderFilter.startDate(); // will bind to (houseService.searchFilter.startDate) when clicking search in search Bar

                // reset the date model ( input field will then display the placeholder value )
                houseService.calenderFilter.selectedDate = null;

                houseService.searchFilter.startDate =
                    houseService.calenderFilter.startDate();

                searchInput.dirty = false;

                // Update the datepicker
                $rootScope.$broadcast("update-date-broadcast", {
                    date: houseService.calenderFilter.startDate(),
                    tooltip: false,
                });
            }
        }

        // UI
        searchInput.animateMenu = false;

        factory.refillInputPlaceholders();

        factory.activatePossibleItems(
            searchInput.defaultItem,
            searchInput.name
        );
    };

    factory.refillInputPlaceholders = function () {
        factory.oSearchCategory.placeholderDisplay = angular.copy(
            factory.oSearchCategory.placeholder
        );
        factory.oSearchType.placeholderDisplay = angular.copy(
            factory.oSearchType.placeholder
        );
        factory.oSearchCalender.placeholderDisplay = angular.copy(
            factory.oSearchCalender.placeholder
        );
        factory.oSearchTime.placeholderDisplay = angular.copy(
            factory.oSearchTime.placeholder
        );
    };

    factory.activatePossibleItems = function (selectedItem, searchType) {
        if (houseService.houseTypesActivityMapping) {
            if (searchType == "search-activity") {
                angular.forEach(
                    houseService.houseTypesActivityMapping.activitytohoustypes,
                    function (aMappedHouseCategory, key) {
                        // The key is the houseCategory
                        // The Value is an array of possible HouseCategories
                        if (
                            key == selectedItem.CategoryID ||
                            selectedItem.CategoryID == 0
                        ) {
                            angular.forEach(
                                houseService.housetypes,
                                function (value) {
                                    if (
                                        aMappedHouseCategory.indexOf(
                                            value.ID
                                        ) != -1
                                    ) {
                                        // -1 = not found in array

                                        value.active = true;
                                    } else {
                                        value.active = false;
                                    }

                                    // If SelectedItem is all houseTypes (alle steder)
                                    if (selectedItem.CategoryID == 0) {
                                        // set all to active
                                        value.active = true;
                                    }
                                }
                            );
                        }
                    }
                );
            }

            if (searchType == "search-location") {
                angular.forEach(
                    houseService.houseTypesActivityMapping.houstypetoactivities,
                    function (aMappedHouseType, key) {
                        // The key is the houseType
                        // The Value is an array of possible HouseCategories

                        if (key == selectedItem.ID || selectedItem.ID == -1) {
                            angular.forEach(
                                houseService.housecategories,
                                function (value) {
                                    var mainCatCount = 0;

                                    angular.forEach(
                                        value.ChildCategories,
                                        function (childVal) {
                                            // Decide whether the childCategories should be set as active or not (bool),
                                            // when compared to the MappingObj
                                            if (
                                                aMappedHouseType.indexOf(
                                                    childVal.CategoryID
                                                ) != -1
                                            ) {
                                                childVal.active = true;
                                                mainCatCount++;
                                            } else {
                                                childVal.active = false;
                                            }

                                            // If SelectedItem is all houseTypes (alle steder)
                                            if (selectedItem.ID == -1) {
                                                // set all to active
                                                childVal.active = true;
                                            }
                                        }
                                    );

                                    // Decide whether the ParentCategory should be set as active or not (bool),
                                    // compares with the count of active children
                                    if (mainCatCount == 0) {
                                        value.active = false;
                                    } else {
                                        value.active = true;
                                    }

                                    // If SelectedItem is all houseTypes (alle steder)
                                    if (selectedItem.ID == -1) {
                                        // set all to active
                                        value.active = true;
                                    }
                                }
                            );
                        }
                    }
                );
            }
        }
    };

    factory.updateActivity = function (activity) {
        houseService.searchFilter.houseCategory = activity;

        activity
            ? factory.selectItem(activity, factory.oSearchCategory, false)
            : null;
    };

    factory.updateLocation = function (location) {
        houseService.searchFilter.houseType = location;

        location
            ? factory.selectItem(location, factory.oSearchType, false)
            : null;
    };
    factory.updateCalender = function (date = null, redirectToSearch = null) {
        // date = expect a date string (DD-MM-YYYY)
        if (date == 0) {
            date = moment().format("DD-MM-YYYY");
        }

        // Update the datepicker
        $rootScope.$broadcast("update-date-broadcast", {
            date: moment(date, "DD-MM-YYYY"),
            tooltip: false,
        });

        factory.oSearchCalender.userSelected.date = date;
        factory.oSearchCalender.placeholderDisplay = "";
        factory.oSearchCalender.dirty = true;

        if (redirectToSearch) {
            // When coming from overview!
            houseService.searchFilter.startDate = date; // Bind directly to results
        }

        houseService.calenderFilter.selectedDate = date;
        houseService.searchFilter.startDateDayOfWeek = moment(
            houseService.searchFilter.startDate,
            "DD-MM-YYYY"
        ).toDate();

        houseService.searchFilter.startDate =
            factory.oSearchCalender.userSelected.date; // update the API param

        houseService.calenderFilter.selectedDate =
            factory.oSearchCalender.userSelected.date; // Update the display value
    };

    factory.updateHours = function () {
        factory.oSearchTime.userSelected.hours =
            houseService.searchFilter.hours;
    };

    // factory.updateTime = function (start, end) {
    //     timeFactory.updateTime(start, end);
    // };

    factory.searchBroadcast = function (setRoute = true) {
        // Copy temp vars to HouseService
        houseService.searchFilter.houseCategory = angular.copy(
            factory.oSearchCategory.buffer
        );
        houseService.searchFilter.houseType = angular.copy(
            factory.oSearchType.buffer
        );

        // force previous selections to display
        factory.oSearchCategory.input = angular.copy(
            houseService.searchFilter.houseCategory.Name
        );
        factory.oSearchType.input = angular.copy(
            houseService.searchFilter.houseType.Name
        );

        const params = UrlFactory.getSearchFilterService();

        factory.updateActivity(params.activity);

        factory.updateLocation(params.location);

        factory.updateCalender(params.date);

        // factory.updateTime(params.start, params.end);

        // factory.updateHours(params.hours);

        // handle UI
        factory.deactivateAllDropdowns();

        factory.checkIfAnySearchBarInputHasValue(); // it should have :-)

        /**
         *  setRoute is set to change the route - Then we do not want to trigger a API call to perform search..
         *  It should happen at the new url which might call this againg with setRoute = false
         */
        if (setRoute) {
            UrlFactory.setRoute(
                params.activity,
                params.location,
                params.date,
                params.start,
                params.end,
                params.hours
            );
        } else {
            if (params.scrollToSearchResults) {
                siteService.scrollToSearchResults = true; // resets itself when scroll is complete
            }

            // Deliver event to Service -> which will broadcast
            houseService.searchFilter.searchNow();
        }
    };

    return factory;
}
